import ipfs from 'decentralized/Ipfs.js';
import {COMMON_TAGS} from 'components/sidebar/constants.js';
import {decodeMP3} from 'mp3/mp3.js';
import Tone from 'tone';
import {NOT_UPLOADED_YET} from 'constants/ipfs-constants.js';
import {WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';
import {decodeFlac} from 'flac/decodeFlac.js';
import Sample from 'repos/Sample.js';
import {
    setDroppedSamples,
    setUploadingFile,
    setSamplesToSave,
    setArrangementBottomMode,
    setShowPianoRoll,
       } from 'actions/index.js';

export function setupDropFiles(sequencerEngine) {
    window.addEventListener("dragenter", function(e) {
        e.preventDefault();
        e.dataTransfer.effectAllowed = "none";
        e.dataTransfer.dropEffect = "none";
    }, false);
    
    window.addEventListener("dragover", function(e) {
        e.preventDefault();
        e.dataTransfer.effectAllowed = "none";
        //e.dataTransfer.dropEffect = "none";
        return false;
    });
    
    window.addEventListener("drop", async (ev) => {
        ev.preventDefault();
        ev.dataTransfer.effectAllowed = "none";
        ev.dataTransfer.dropEffect = "none";
        
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            let len = ev.dataTransfer.items.length;
            sequencerEngine.dispatch(
                setDroppedSamples(len));
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (ev.dataTransfer.items[i].kind === 'file') {
                    sequencerEngine.dispatch(setUploadingFile(true));
                    uploadFile(sequencerEngine, ev.dataTransfer.items[i].getAsFile());
                }
            }
        } else {
            // Use DataTransfer interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
            }
        }
        return false;
    });
};
 
function uploadFile(sequencerEngine, file) {
    let reader = new FileReader();
    if (!file.name.includes('.wav') && !file.name.includes('.flac') && !file.name.includes('.mp3')) {
        window.alert('Only accepts .wav, .mp3, & .flac files for now');
        return;
    }
    reader.readAsArrayBuffer(file)
    reader.onloadend = async () => {
        let raw = reader.result;
        let audioBuffer;
        let sample = new Sample(NOT_UPLOADED_YET);
        if (file.name.includes('flac')) {
            raw = await decodeFlac(new Int8Array(raw));
            audioBuffer = await Tone.Master.context.decodeAudioData(raw);
        } else if (file.name.includes('mp3')) {
            audioBuffer = await decodeMP3(new Int8Array(raw));
            sample.mp3Data = new Buffer(raw);
        } else {
            audioBuffer = await Tone.Master.context.decodeAudioData(raw);
        }

        sample.tags = [];
        for (let tag of COMMON_TAGS) {
            if (file.name.toLowerCase().includes(tag.toLowerCase())) {
                sample.tags.push(tag);
            }
        }

        if (sample.tags.length > 0) {
            console.log("tags for %s = ", file.name, sample.tags);
        }
  
        // let hash = await ipfs.addArrayBuffer(raw);
        sample.audioBuffer = audioBuffer;
        sample.needsSave = true;
        // await sample.fetchAudio();
        sequencerEngine.dispatch(setUploadingFile(false));
        sample.name = file.name;
        sequencerEngine.recordingsToSave.push(sample);
        // await sequencerEngine.addSound(sample);
        
        let samplesToSave = [... sequencerEngine.state.samples.samplesToSave];
        sequencerEngine.dispatch(setSamplesToSave(
            [... samplesToSave, sample]));
        /*
        sequencerEngine.store.dispatch(setArrangementBottomMode(WAVEFORM));
        sequencerEngine.store.dispatch(setShowPianoRoll(true));
        */
    };
}
